/*
 *  Cart Note
 *    Scripts to control the cart note functionality on cart drawer and cart page.
 *
 *  Version:
 *    1.0.0 - 2023/07/11
 */

import $ from 'jquery';

import { setCartNote } from '@process-creative/slate-theme-tools';

export const SELECTOR_NOTE = `[data-cart-notes]`;
const SELECTOR_TOGGLE = `[data-cart-notes-toggle]`;
const SELECTOR_TEXT = `[data-cart-notes-textarea]`;
const SELECTOR_NOTE_ADD = '[data-cart-notes-add]';
const SELECTOR_NOTE_REMOVE = '[data-cart-notes-remove]';
const SELECTOR_NOTE_PREVIEW = '[data-cart-notes-note]';

const ATTR_VARIANT = `data-cart-notes-variant`;

const CLASS_SHOW = 'is-expanded';
const CLASS_NOTE = 'has-note';

 
export class CartNote {
  constructor(container) {
    this.container = container;
    this.note = container.find(SELECTOR_TEXT);
    this.notePreview = container.find(SELECTOR_NOTE_PREVIEW);

    this.loadNotes();

    container.on('click', SELECTOR_TOGGLE, e => this.toggleNotes(e));
    container.on('click', SELECTOR_NOTE_ADD, e => this.addNotes(e));
    container.on('click', SELECTOR_NOTE_REMOVE, e => this.deleteNotes(e));
  }

  loadNotes() {
    if (this.notePreview.html() != '') {
      this.container.addClass(CLASS_NOTE)
    }
  }

  toggleNotes(e) {
    e.preventDefault();

    let isOpen = this.container.hasClass(CLASS_SHOW);
    
    if(!isOpen) {
      this.container.addClass(CLASS_SHOW);
    } else {
      if ($(e.target).hasClass('is-add')) { return; }

      this.container.removeClass(CLASS_SHOW);
    }
  }

  async addNotes(e) {
    e.preventDefault();

    const note = this.note.val();
    if(!note) return;

    await setCartNote(note).then(() => {
      this.container.removeClass(CLASS_SHOW);
      this.container.addClass(CLASS_NOTE);
      this.notePreview.html(note);
    }).catch(e => console.warn(e));
  }

  async deleteNotes(e) {
    e.preventDefault();

    await setCartNote('').then(() => {
      this.container.removeClass(CLASS_NOTE);
      this.notePreview.html('');
      this.note.val('');
    }).catch(e => console.warn(e));
  }
}